<template>
    <v-btn
        v-if="isLoggedIn && pageLink"
        variant="text"
        :href="pageLink"
        :class="{ 'v-btn--slim': colorTheme == 'inverted' }"
        class="my-profile-link"
    >
        <template #prepend>
            <v-sheet
                rounded="circle"
                width="20"
                height="20"
                class="d-flex align-center justify-center"
                :class="{ 'v-btn--highlighted': colorTheme == 'inverted' }"
            >
                <v-icon :icon="icon" size="18" :color="colorTheme == 'inverted' ? 'white' : 'green'" />
            </v-sheet>
        </template>
        {{ title || '' }}
    </v-btn>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface Props {
    title?: string;
    pageLink?: string;
    isLoggedIn: boolean;
    colorTheme?: string;
    linkType?: 'account' | 'page';
}
const props = defineProps<Props>();

const icon = computed(() => {
    return props.linkType === 'account' ? 'mdi-account' : 'mdi-home-outline';
});
</script>

<style lang="scss">
@use 'vuetify/settings' as *;

.my-profile-link.v-btn {
    color: var(--v-color-white);
    text-transform: none;

    .v-btn--highlighted {
        background-color: var(--v-color-green-darken-1);
    }
}
</style>
